import styled from 'styled-components';

/* Port of the marketplace no-photo monogram (ProductImage fallback in
   pages/marketplace). Transparent background so the host panel keeps its
   own tint (stock-state / pastel); the glyph reads in brand navy.
   `&&` out-specifies host panels' own `svg { … }` rules. */
export const StyledProductMonogram = styled.div<{ $scale?: number }>`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  align-content: center;
  gap: ${({ $scale }) => Math.round(6 * ($scale ?? 1))}px;
  color: var(--ink);

  && span {
    font-size: ${({ $scale }) => Math.round(34 * ($scale ?? 1))}px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    opacity: 0.55;
  }

  && svg {
    width: ${({ $scale }) => Math.round(20 * ($scale ?? 1))}px;
    height: ${({ $scale }) => Math.round(20 * ($scale ?? 1))}px;
    color: var(--ink);
    opacity: 0.35;
  }
`;
